import React, { useState, useEffect, useRef, ReactNode } from "react";
import clsx from "clsx"

import AppBox from "@/components/AppBox"

interface AppTableContainerProps {
  children: ReactNode;
  className?: string;
}

const AppTableContainer: React.FC<AppTableContainerProps> = ({ children, className = "" }) => {
  const [tableHeight, setTableHeight] = useState<number | "auto">("auto");
  const tableRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const updateTableHeight = () => {
      if (tableRef.current) {
        const tableTop = tableRef.current.getBoundingClientRect().top;
        setTableHeight(window.innerHeight - tableTop - 16);
      }
    };

    updateTableHeight(); // Initial call to set height
    window.addEventListener("resize", updateTableHeight);

    return () => window.removeEventListener("resize", updateTableHeight);
  }, []);

  return (
    <AppBox
      ref={tableRef}
      className={clsx(
        `w-full overflow-y-auto rounded-sm items-start z-30`,
        className
      )}
      style={{
        maxHeight: tableHeight !== "auto" ? `${tableHeight}px` : "auto",
      }}
    >
      {children}
    </AppBox>
  );
};

export default AppTableContainer;